"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtbxHourly = void 0;
const rtbxInterval_1 = require("./rtbxInterval");
const moment = require('moment');
class RtbxHourly extends rtbxInterval_1.RtbxInterval {
    static deserialize(params = {}) {
        return new RtbxHourly(params);
    }
    static sumColumn(rawMetricColumn, hourlyArray, header) {
        let dailySum = 0;
        hourlyArray.forEach(hour => {
            // if the adjustedColumn/rawMetricColumn has a value, use it
            // otherwise default to the baseMetric
            let numberToAdd = Number(hour[rawMetricColumn]);
            if (hour[rawMetricColumn] !== 0 && !hour[rawMetricColumn]) {
                numberToAdd = Number(hour[hour.getBaseMetric(header)]);
            }
            dailySum += numberToAdd;
        });
        return dailySum;
    }
    constructor(params = {}, hourlyParams = {}) {
        super(params);
        Object.assign(this, {
            hour: moment(params.tz_datehour).utc().format('HH:mm:ss'),
            percent_dfp_revenue: parseFloat(params.percent_dfp_revenue),
            percent_renders: parseFloat(params.percent_renders)
        });
    }
    downfillImpsAdj(dailyValue) {
        this.impsAdj = Number((Number(dailyValue) * Number(this.percent_renders)).toFixed(0));
    }
    downfillRevAdj(dailyValue) {
        this.revAdj = Number((Number(dailyValue) * Number(this.percent_dfp_revenue)).toFixed(2));
    }
    diff() {
        let diff = {};
        if (this.impsAdjDiff()) {
            diff.hour = this.hour;
            diff.impsAdj = this.impsAdj;
        }
        if (this.revAdjDiff()) {
            diff.hour = this.hour;
            diff.revAdj = this.revAdj;
        }
        return diff;
    }
}
exports.RtbxHourly = RtbxHourly;
//# sourceMappingURL=rtbxHourly.js.map